import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About Us</h2>
          <p className="section-subtitle">Who We Are</p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <h3>Our Mission</h3>
            <p>
              At Veltroz, we are driven by a singular vision: to transform innovative ideas 
              into powerful solutions that shape the future. We believe in pushing boundaries, 
              challenging conventions, and creating technology that makes a meaningful impact.
            </p>
            <h3>Our Vision</h3>
            <p>
              To be the leading force in innovation, recognized globally for our cutting-edge 
              solutions and unwavering commitment to excellence. We envision a world where 
              technology seamlessly integrates with human needs, creating opportunities and 
              possibilities that were once unimaginable.
            </p>
            <h3>Our Values</h3>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">💡</div>
                <h4>Innovation</h4>
                <p>We constantly explore new frontiers and embrace creative solutions.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🎯</div>
                <h4>Excellence</h4>
                <p>We strive for perfection in every project we undertake.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🤝</div>
                <h4>Collaboration</h4>
                <p>We believe in the power of teamwork and shared success.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🚀</div>
                <h4>Growth</h4>
                <p>We are committed to continuous learning and development.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

